export var InsuranceLevel;
(function (InsuranceLevel) {
    InsuranceLevel["STANDARD"] = "STANDARD";
    InsuranceLevel["PREMIUM"] = "PREMIUM";
    InsuranceLevel["FULL"] = "FULL";
})(InsuranceLevel || (InsuranceLevel = {}));
